export default __webpack_public_path__ + "static/media/IconStar2.debff26e.svg";